define(
	'Tavanoteam.TavanoTeam_SubHeader_Extension.SubHeader'
	, [
		'Utils'
	]
	, function (
		Utils
	) {

		'use strict';

		return {
			mountToApp: function mountToApp(container) {

				var environment = container.getComponent("Environment");

				var layout = container.getComponent('Layout');

				var subHeaderConfig = environment.getConfig('tavanoTeamSubHeaderExtension');

				var columns = subHeaderConfig.columns;

				var links = [];

				links = links.concat(subHeaderConfig.links.ecommerceLinks, subHeaderConfig.links.otherLinks);

				// Order links by columns and position
				columns.sort(function (a, b) { return a.column - b.column; });

				// Order links by columns and position
				links.sort(function (a, b) { return a.order - b.order; });

				// Configure HTML Content
				var configureHTMLContent = function (html) {

					if (!!html) {
						
						// Translate
						var translate_text = html.split("translate[[");
						if (translate_text.length > 1) {
							translate_text.shift();
							for (var i = 0; i < translate_text.length; i++) {
								translate_text[i] = translate_text[i].split("]]")[0];
								var value_origin = "translate[[" + translate_text[i] + "]]";
								var value_translated = Utils.translate(translate_text[i]);
								html = html.replace(value_origin, value_translated);
							}
						}

						// Remove whitespaces in the DOM.
						// It's not a common space (Red Dots - ""). Do NOT remove this line!
						html = html.replace(/\5/g, "");
					}

					return html;
				}

				// Column Width
				var getColumnWidth = function (width) {

					switch (width) {
						case '20%': width = 'tt-ext-subheader-col-20'; break; // 20%
						case '25%': width = 'tt-ext-subheader-col-25'; break; // 25%
						case '30%': width = 'tt-ext-subheader-col-30'; break; // 30%
						case '40%': width = 'tt-ext-subheader-col-40'; break; // 40%
						case '50%': width = 'tt-ext-subheader-col-50'; break; // 50%
						case '60%': width = 'tt-ext-subheader-col-60'; break; // 60%
						case '70%': width = 'tt-ext-subheader-col-70'; break; // 70%
						case '75%': width = 'tt-ext-subheader-col-75'; break; // 75%
						case '80%': width = 'tt-ext-subheader-col-80'; break; // 80%
						case '100%': width = 'tt-ext-subheader-col-100'; break; // 100%
						case 'auto': width = 'tt-ext-subheader-col-auto'; break; // auto
					}

					return width;
				}

				// Create Columns with Links
				for (var i = 0; i < columns.length; i++) {

					var columnLinks = [];

					for (var j = 0; j < links.length; j++) {

						if (columns[i].column === links[j].column) {

							var link = {};

							// Type
							var addLink = false;
							switch (links[j].linkType) {
								case "Cart *":
									link.cart = true;
									link.dropdownSide = links[j].dropdownSide;
									addLink = true;
									break;
								case "Login Register *":
									link.loginRegister = true;
									link.hideIcon = !links[j].icon;
									addLink = true;
									break;
								case "Store Locator":
									link.storeLocator = true;
									link.hideIcon = !links[j].icon;
									addLink = true;
									break;
								case "Site Settings":
									link.siteSettings = true;
									link.label = links[j].label;
									link.mobileLabel = links[j].mobileLabel;
									link.dropdownSide = links[j].dropdownSide;
									link.icon = links[j].icon;
									addLink = true;
									break;
								case "Request a Quote":
									link.requestQuote = true;
									addLink = true;
									break;
								case "Quick Order":
									link.quickOrder = true;
									addLink = true;
									break;
								case "Information":
									link.infoLink = true;
									link.link = links[j].link;
									link.hashtag = "#" + links[j].link;
									link.touchpoint = "home";
									link.label = links[j].label;
									link.mobileLabel = links[j].mobileLabel;
									link.icon = links[j].icon;
									link.newWindow = links[j].newWindow;
									addLink = true;
									break;
								case "Phone":
									link.phoneLink = true;
									link.link = links[j].link;
									link.label = links[j].label;
									link.mobileLabel = links[j].mobileLabel;
									link.icon = links[j].icon;
									addLink = true;
									break;
								case "Mail":
									link.mailLink = true;
									link.link = links[j].link;
									link.label = links[j].label;
									link.mobileLabel = links[j].mobileLabel;
									link.icon = links[j].icon;
									addLink = true;
									break;
								case "Text":
									if (!!links[j].label) {
										link.html = links[j].label;
										links[j].additionalClass = "tt-ext-subheader-html " + links[j].additionalClass
										addLink = true;
									}
									break;
								case "Link":
									if (!!links[j].label) {
										link.customLink = true;
										link.link = links[j].link;
										link.hashtag = links[j].hashtag;
										link.touchpoint = links[j].touchpoint;
										link.label = links[j].label;
										link.mobileLabel = links[j].mobileLabel;
										link.newWindow = links[j].newWindow;
										addLink = true;
									}
									break;
							}

							if (addLink) {

								// Class
								link.class = "";
								if (!!links[j].displayDesktop) {
									link.class += " tt-ext-subheader-display-desktop";
								}
								if (!!links[j].displayTablet) {
									link.class += " tt-ext-subheader-display-tablet";
								}
								if (!!links[j].displayMobile) {
									link.class += " tt-ext-subheader-display-mobile";
								}
								if (!!link.dropdownSide) {
									link.class += " tt-ext-subheader-dropdown-" + link.dropdownSide.toLowerCase();
								}
								if (!!link.hideIcon) {
									link.class += " tt-ext-subheader-hide-icon";
								}
								if (!!links[j].additionalClass) {
									link.class += " " + links[j].additionalClass;
								}

								link.separator = links[j].separator;

								// Add Column with link
								columnLinks.push(link);
							}
						}
					}

					// Column Class
					var columnClass = "";
					// Column Width
					columnClass += getColumnWidth(columns[i].desktopWidth) + "-desktop ";
					columnClass += getColumnWidth(columns[i].tabletWidth) + "-tablet ";
					columnClass += getColumnWidth(columns[i].mobileWidth) + "-mobile ";
					// Alignment
					columnClass += !!columns[i].alignment ? "tt-ext-subheader-align-" + columns[i].alignment.toLowerCase() + " " : "";
					columnClass += !!columns[i].additionalClass ? columns[i].additionalClass : "";

					// Column Styles
					var styles = '';
					if (!!columns[i].padding) {
						styles = 'padding: ' + columns[i].padding + ';';
					}

					// Set Column Data
					columns[i] = {
						class: columnClass,
						styles: styles,
						links: columnLinks
					};
				}

				// Send data to Header
				if (layout) {

					layout.addToViewContextDefinition('Header.View', 'ttSubHeaderExtension', 'array', function (context) {

						return {

							topMessage: configureHTMLContent(subHeaderConfig.topMessage.html),
							columns: columns
						};
					});

				}
			}
		};
	}
);
